export { Box as default } from 'theme-ui';
